// Opt-in timing for the production performance report. The hot paths only
// read a null reference when no report is running.
let activeProbe = null;

export function startUiWorkProbe() {
  activeProbe = { samples: [], gauges: {} };
}

export function setUiWorkGauge(name, value) {
  if (activeProbe) activeProbe.gauges[name] = value;
}

export function uiWorkStartedAt() {
  return activeProbe && typeof performance !== 'undefined' ? performance.now() : null;
}

export function recordUiWork(name, startedAt) {
  const probe = activeProbe;
  if (!probe || startedAt === null || !Number.isFinite(startedAt)) return;
  const endedAt = performance.now();
  if (probe.samples.length < 5000) {
    probe.samples.push({ name, startedAt, endedAt, durationMs: endedAt - startedAt });
  }
}

export function finishUiWorkProbe(longTasks = []) {
  const probe = activeProbe;
  activeProbe = null;
  const samples = probe?.samples || [];
  const categories = {};
  for (const sample of samples) {
    const entry = categories[sample.name] || { count: 0, totalMs: 0, worstMs: 0 };
    entry.count += 1;
    entry.totalMs += sample.durationMs;
    entry.worstMs = Math.max(entry.worstMs, sample.durationMs);
    categories[sample.name] = entry;
  }
  for (const entry of Object.values(categories)) {
    entry.totalMs = Number(entry.totalMs.toFixed(1));
    entry.worstMs = Number(entry.worstMs.toFixed(1));
  }

  const worstLongTasks = [...longTasks]
    .sort((a, b) => b.duration - a.duration)
    .slice(0, 8)
    .map((task) => {
      const end = task.startTime + task.duration;
      const overlap = {};
      for (const sample of samples) {
        if (sample.startedAt >= end || sample.endedAt <= task.startTime) continue;
        overlap[sample.name] = (overlap[sample.name] || 0) + 1;
      }
      return {
        atMs: Number(task.startTime.toFixed(1)),
        durationMs: Number(task.duration.toFixed(1)),
        overlap,
        attribution: task.attribution || []
      };
    });
  return { gauges: probe?.gauges || {}, categories, worstLongTasks };
}
